import { Loader2 } from "lucide-react";

/**
 * RouteSpinner — neutralny fallback loadingu.
 * `variant="route"` (domyślnie) — pełny widok trasy (min-h 50vh).
 * `variant="inline"` — mniejszy spinner do sekcji/paneli/modali.
 */
interface RouteSpinnerProps {
  variant?: "route" | "inline";
  className?: string;
  label?: string;
}

const RouteSpinner = ({ variant = "route", className = "", label = "Ładowanie" }: RouteSpinnerProps) => {
  const isInline = variant === "inline";
  return (
    <div
      className={`flex items-center justify-center w-full ${isInline ? "py-8" : "min-h-[50vh]"} ${className}`}
      role="status"
      aria-label={label}
    >
      <Loader2
        className={`animate-spin text-muted-foreground ${isInline ? "w-6 h-6" : "w-8 h-8"}`}
      />
    </div>
  );
};

export default RouteSpinner;